<template>
  <div class="settle">
    <nav-bar fixed z-index="99" title="" left-text="返回" left-arrow @click-left="$router.go(-1)" />
    <div style="height: 46px"></div>
    <div class="title">
      <!-- {{
        isFromUser ? "预约资料" : $route.query.type == 0 ? "首次预约" : "续约"
      }} -->
      <span v-if="isFromUser">预约资料</span>
      <span v-else-if="$route.query.type == 0">首次预约</span>
      <span v-else-if="$route.query.type == 1">续约</span>
      <span v-else-if="$route.query.type == 2">公益预约</span>
      <span v-else-if="$route.query.type == 3">单次预约</span>

    </div>
    <form class="settle-form acea-row row-column" @submit.prevent="submit">
      <div style="color: #ff1255; text-align: center; font-size: 0.24rem">
        为方便为您匹配到更合适的教练，以下内容请仔细填写
      </div>
      <div class="settle-box">
        <div class="box-item acea-row row-between-wrapper">
          <div class="name">您的性别</div>
          <div class="acea-row row-between-wrapper">
            <div class="sex-item" :class="{ active: form.sex == item.value }" @click="form.sex = item.value"
                 v-for="(item, index) in sexList" :key="index">
              <svg t="1683182891346" class="icon" viewBox="0 0 1024 1024" version="1.1"
                   xmlns="http://www.w3.org/2000/svg" p-id="19642" width="64" height="64" v-if="item.label === '男'">
                <path
                  d="M456.57732 427.546392c-79.175258 0-142.515464 63.340206-137.237114 142.515464 0 73.896907 63.340206 137.237113 137.237114 137.237113 36.948454 0 73.896907-15.835052 100.288659-42.226804s42.226804-63.340206 36.948454-100.28866c0-79.175258-63.340206-137.237113-137.237113-137.237113z"
                  fill="#bfbfbf" p-id="19643"></path>
                <path
                  d="M514.639175 31.670103c-263.917526 0-475.051546 211.134021-475.051546 475.051546s211.134021 475.051546 475.051546 475.051547 475.051546-211.134021 475.051547-475.051547-211.134021-475.051546-475.051547-475.051546z m263.917526 242.804124v221.690721c0 15.835052-10.556701 26.391753-26.391753 26.391753s-26.391753-10.556701-26.391752-26.391753V343.092784l-100.28866 100.288659c26.391753 31.670103 36.948454 73.896907 42.226804 116.123712 0 52.783505-21.113402 105.56701-58.061855 147.793814-36.948454 36.948454-89.731959 63.340206-142.515464 63.340206h-5.278351c-110.845361 0-200.57732-89.731959-205.85567-200.577319 0-110.845361 89.731959-205.85567 200.57732-205.85567h5.27835c47.505155 0 89.731959 15.835052 126.680412 42.226804l100.28866-100.28866H535.752577c-15.835052 0-26.391753-10.556701-26.391752-26.391753s10.556701-26.391753 26.391752-26.391752h226.969072l15.835052 21.113402c0-5.278351 0-5.278351 0 0 0-5.278351 0 0 0 0z"
                  fill="#bfbfbf" p-id="19644"></path>
              </svg>
              <svg t="1683183057128" class="icon" viewBox="0 0 1024 1024" version="1.1"
                   xmlns="http://www.w3.org/2000/svg" p-id="38845" width="64" height="64" v-else>
                <path
                  d="M417.16736 450.56c0 87.72608 71.11168 158.83264 158.83264 158.83264 87.72608 0 158.83264-71.11168 158.83264-158.83264S663.72096 291.72736 576 291.72736 417.16736 362.83904 417.16736 450.56z"
                  fill="#bfbfbf" p-id="38846"></path>
                <path
                  d="M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512S793.6 0 512 0z m217.6 596.48c-76.8 74.24-194.56 84.48-281.6 20.48L409.6 655.36l87.04 87.04-43.52 43.52-87.04-87.04L276.48 788.48l-43.52-43.52L322.56 655.36l-87.04-87.04 43.52-43.52 87.04 87.04 40.96-40.96c-61.44-84.48-51.2-202.24 23.04-276.48 84.48-71.68 209.92-66.56 289.28 12.8s81.92 204.8 10.24 289.28z"
                  fill="#bfbfbf" p-id="38847"></path>
              </svg>
              <p>{{ item.label }}</p>
            </div>
          </div>
        </div>
        <div class="box-item" @click="showPicker = true">
          <div class="name">渠道选择</div>
          <div class="input acea-row row-between-wrapper">
            <div :class="{ empty: !form.provider }">
              {{ form.provider || "请选择渠道" }}
            </div>
            <Icon name="arrow" color="#999999"></Icon>
          </div>
        </div>

        <div class="box-item" v-show="form.provider == '朋友介绍'">
          <div class="name">朋友姓名</div>
          <div class="input">
            <input class="w-f" v-model="form.name" placeholder="请输入朋友姓名" />
          </div>
        </div>

        <div class="box-item question-item acea-row" @click="directionPicker = true">
          <div class="name" style="flex-wrap: nowrap">本次教练中你想聚焦在</div>
          <div class="input input-b" style="pointer-events: none">
            <input class="w-f" disabled :value="form.directionText" placeholder="" />
          </div>
        </div>
        <div v-if="form.direction == 2 || form.direction == 3">
          <div class="box-item question-item acea-row" @click="numPicker = true">
            <div class="name">您家中孩子的数量</div>
            <div class="input input-b">
              <input class="w-f" type="number" disabled :value="form.childNum" placeholder="" />
            </div>
          </div>
          <div class="box-item">
            本次教练中你想聚焦的孩子（多个时可任选其一）
          </div>
          <div>
            <div class="box-item question-item acea-row" @click="show = true">
              <div class="name">孩子的出生日期</div>
              <div class="input input-b">
                <input class="w-f" disabled :value="dateTram(form.childBirthday)" placeholder="选填" />
              </div>
            </div>
            <div class="box-item question-item acea-row" @click="sexPicker = true">
              <div class="name">孩子性别</div>
              <div class="input input-b">
                <input class="w-f" disabled :value="form.childSexText" placeholder="选填" />
              </div>
            </div>
            <div class="box-item question-item acea-row" @click="relationPicker = true">
              <div class="name">您与孩子的关系</div>
              <div class="input input-b">
                <input class="w-f" disabled :value="form.childRelationText" placeholder="选填" />
              </div>
            </div>
          </div>
        </div>
        <div class="box-item">
          <div class="name">需求描述</div>
          <div class="input">
            <input class="w-f" v-model="form.remark" placeholder="请详细描述您遇到的问题" />
          </div>
        </div>

        <div class="box-item">
          <div class="name">被教练对象</div>
          <CheckboxGroup v-model="form.detailFjson" @change="checkboxChange">
            <div class="box-check" v-for="(item, index) in detailFjson" :key="index">
              <Checkbox shape="square" checked-color="#0ce6df" :name="item.value">{{ item.label }}</Checkbox>
            </div>
          </CheckboxGroup>
        </div>

        <div class="btn" style="margin-top: 0.3rem" @click="submit">
          {{ isFromUser ? "保存" : "预约" }}
        </div>
      </div>
    </form>
    <Popup v-model="directionPicker" round position="bottom">
      <Picker value-key="label" show-toolbar :columns="directionColumns" @cancel="directionPicker = false"
              @confirm="directionConfirm" />
    </Popup>
    <Popup v-model="showPicker" round position="bottom">
      <Picker value-key="name" show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" />
    </Popup>
    <Popup v-model="sexPicker" round position="bottom">
      <Picker value-key="label" show-toolbar :columns="sexColumns" @cancel="sexPicker = false" @confirm="sexConfirm" />
    </Popup>
    <Popup v-model="numPicker" round position="bottom">
      <Picker show-toolbar :columns="numColumns" @cancel="numPicker = false" @confirm="numConfirm" />
    </Popup>
    <Popup v-model="relationPicker" round position="bottom">
      <Picker value-key="label" show-toolbar :columns="relationColumns" @cancel="relationPicker = false"
              @confirm="relationConfirm" />
    </Popup>
    <Popup v-model="show" round position="bottom">
      <datetime-picker v-model="form.childBirthday" type="date" title="选择年月日" :min-date="minDate" :max-date="maxDate"
                       @confirm="show = false" />
    </Popup>

    <!-- 协议确认弹窗 -->
    <Popup v-model="showDialog" round>
      <div class="agree-title">
        <template v-if="$route.query.pageType != 'coach'">
          {{ [0, 3].includes(Number($route.query.type)) ? articleInfo.title : articleInfo1.title }}
        </template>
        <template v-else>
          {{ articleInfo2.title }}
        </template>
      </div>
      <div class="agree-content">
        <template v-if="$route.query.pageType != 'coach'">
          <div v-html="articleInfo.content" v-if="[0, 3].includes(Number($route.query.type))"></div>
          <div v-html="articleInfo1.content" v-else></div>
        </template>
        <template v-else>
          <div v-html="articleInfo2.content"></div>
        </template>
      </div>
      <div class="agree-btn" @click="dialogAction(true)">确认</div>
    </Popup>
    
    <!-- 新增：套餐信息弹窗 -->
    <Popup v-model="showPackageInfo" round>
      <Icon name="cross" class="popup-close-icon" @click="closePackageInfo" />
      <div class="agree-title">套餐信息</div>
      <div class="package-content">
        <div class="package-item">
          <span class="package-label">套餐名称：</span>
          <span class="package-value">{{ tempLinkData.name || "未知套餐" }}</span>
        </div>
        <div class="package-item">
          <span class="package-label">套餐价格：</span>
          <span class="package-value price">¥{{ tempLinkData.price }}</span>
        </div>
        <div class="package-item">
          <span class="package-label">单次价格：</span>
          <span class="package-value price">¥{{ tempLinkData.onePrice }}</span>
        </div>
        <div class="package-item">
          <span class="package-label">旅程次数</span>
          <span class="package-value price">{{ tempLinkData.sku }}次</span>
        </div>
        <div class="package-item">
          <span class="package-label">优惠券：</span>
          <span class="package-value" @click="openCouponSelector">
            {{ usableCoupon.couponTitle || '请选择优惠券' }}
          </span>
        </div>
      </div>
      <div class="agree-btn" @click="confirmPackageInfo">确认</div>
      <!-- 新增：优惠券选择弹窗 -->
      <CouponListWindow
        v-model="showCoupon"
        :cartid="cartId"
        :type="0"
        :checked="usableCoupon.id"
        :isTempLink="isFromTempLink"
        @checked="handleCouponChecked"
      />
    </Popup>
  </div>
</template>
<script>
import {
  Icon,
  Picker,
  Popup,
  DatetimePicker,
  Checkbox,
  CheckboxGroup,
  NavBar,
} from "vant";
import { getDict, getProvider } from "@api/admin";
import debounce from "lodash.debounce";
import { orderFirstInfo, firstInfo, createOrder, postOrderConfirm,getOrderCouponTemp } from "@api/order";
import { getUserInfo } from "@api/user";
import { mapGetters } from "vuex";
import {
  postCartAdd,
} from "@api/store";
import { pay } from "@libs/wechat";
import { getViewDetails } from "@api/public";
import CouponListWindow from "@components/CouponListWindow";

export default {
  name: "SettleIn",
  components: {
    Icon,
    Picker,
    Popup,
    DatetimePicker,
    Checkbox,
    CheckboxGroup,
    NavBar,
    CouponListWindow,
  },
  data: function () {
    return {
      show: false,
      form: {
        sex: 1,
        provider: "",
        directionText: "",
        childNum: 2,
        childBirthday: "",
        childSexText: "",
        childRelationText: "",
        detailFjson: [],
        remark: "",
      },
      showPicker: false,
      columns: [],
      type: {},
      sexList: [],
      numColumns: [1, 2, 3, 4, 5],
      numPicker: false,
      sexColumns: [],
      sexPicker: false,
      relationColumns: [],
      relationPicker: false,
      detailFjson: [],
      agree: [],
      isFromUser: false,
      minDate: new Date(1998, 0, 1),
      maxDate: new Date(),
      directionColumns: [
        { label: "成人", value: 1 },
        { label: "孩子", value: 2 },
        { label: "成人&孩子", value: 3 },
      ],
      directionPicker: false,

      // 协议相关
      showDialog: false,
      articleInfo: {},
      articleInfo1: {},
      articleInfo2: {},
      formValidated: false, // 表单验证标记
      
      // 新增：套餐信息弹窗状态
      showPackageInfo: false,
      
      // 从首页temp链接传递过来的数据
      isFromTempLink: false,
      tempLinkData: {
        temp: null,
        orderId: null,
        uniqueId: "",
        productId: null,
        price: 0,
        name: "未知套餐" // 新增套餐名称
      },
      
      // 添加一个标志位，防止循环触发
      isProcessingCheckbox: false,
      showCoupon: false, // 控制优惠券弹窗显示
      usableCoupon: {}, // 当前选中的优惠券对象
      couponList: [], // 可用优惠券列表
      couponId: 0, // 选中的优惠券ID
      cartId: null, // 新增购物车ID
    };
  },
  async created() {
    this.isFromUser = this.$route.query.form === "user";
    
    // 检查是否从首页temp链接跳转而来
    this.checkTempParam();
    
    const userRes = await getUserInfo();
    const userInfo = userRes.data;
    if (!userInfo.phone) {
      // this.$dialog.toast({ mes: "完善基础信息" });
      // return;
      this.$dialog.confirm({
        mes: "您的用户基础信息尚未填写，为了便于教练联系到您，请补充完整。",
        opts: [
          {
            txt: "返回",
            color: false,
            callback: () => {
              this.$router.go(-1);
            },
          },
          {
            txt: "去完善",
            color: true,
            callback: () => {
              this.$router.push("/settle_in?stepActive=1");
            },
          },
        ],
      });
      return;
    }

    const sexRes = await this.getDict("sex_code");
    this.sexList = sexRes.data;
    this.sexColumns = sexRes.data;
    this.form.sex = sexRes.data[0].value;

    const relationRes = await this.getDict("child_relation");
    this.relationColumns = relationRes.data;

    const sqRes = await this.getDict("yu_sq");
    this.detailFjson = sqRes.data;
    
    const provRes = await this.getProvider();
    this.columns = provRes.data;

    // 获取协议内容
    this.getAgree();

    this.getFirstInfo();
  },
  computed: mapGetters(["userInfo", "storeItems"]),
  methods: {
    getDict: function (name, cal) {
      return new Promise((resolve, reject) => {
        getDict({ name })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getFirstInfo: function (name, cal) {// 获取预约信息
      firstInfo().then((res) => {
        if (!res.data) return;
        for (let key in res.data) {
          res.data[key] && (this.form[key] = res.data[key]);
        }
        this.form.providerId &&
        (() => {
          const provider = this.columns.find(
            (ele) => ele.id == this.form.providerId
          );
          provider && (this.form.provider = provider.name);
        })();
        this.form.childSex &&
        (() => {
          const sex = this.sexColumns.find(
            (ele) => ele.value == this.form.childSex
          );
          sex && (this.form.childSexText = sex.label);
        })();
        this.form.childRelation &&
        (() => {
          const relation = this.relationColumns.find(
            (ele) => ele.value == this.form.childRelation
          );
          relation && (this.form.childRelationText = relation.label);
        })();
        this.form.detailFjson = res.data.detailFjson
          ? res.data.detailFjson.split(",")
          : [];
      });
    },
    getProvider: function () {
      return new Promise((resolve, reject) => {
        getProvider()
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    // 获取各种协议
    getAgree: function () {
      getViewDetails(48).then((res) => {
        this.articleInfo = res.data;
      });
      getViewDetails(51).then((res) => {
        this.articleInfo1 = res.data;
      });
      getViewDetails(53).then((res) => {
        this.articleInfo2 = res.data;
      });
    },

    // 提交预约信息
    submit: debounce(function () {
      if (this.form.direction == 2 || this.form.direction == 3) {
        if (!this.form.childNum) {
          this.$dialog.toast({ mes: "请选择孩子的数量" });
          return;
        }
      }
      if (!this.form.remark) {
        this.$dialog.toast({ mes: "请填写您的需求" });
        return;
      }
      const params = JSON.parse(JSON.stringify(this.form));
      delete params.provider;
      delete params.childSexText;
      delete params.childRelationText;
      delete params.direction;
      delete params.directionText;

      // 如果是用户信息编辑页面，直接保存
      if (this.isFromUser) {
        this.submitUserInfo(params);
        return;
      }

      // 表单验证通过，保存表单数据然后弹出协议
      orderFirstInfo({
        ...params,
        detailFjson: params.detailFjson.join(","),
        ...(params.childBirthday && {
          childBirthday: this.dateTram(params.childBirthday),
        }),
      }).then((res) => {
        if (res.status === 200) {
          this.formValidated = true;
          
          // 如果是从首页temp链接跳转过来的，显示协议弹窗
          if (this.isFromTempLink) {
            // 显示协议确认弹窗
            this.showDialog = true;
          } else {
            // 原有流程：表单提交成功后，弹出协议确认
            this.showDialog = true;
          }
        } else {
          this.$dialog.error(res.msg);
        }
      });
    }),

    // 保存用户信息
    submitUserInfo(params) {
      orderFirstInfo({
        ...params,
        detailFjson: params.detailFjson.join(","),
        ...(params.childBirthday && {
          childBirthday: this.dateTram(params.childBirthday),
        }),
      }).then((res) => {
        if (res.status === 200) {
          this.$router.go(-1);
        } else {
          this.$dialog.error(res.msg);
        }
      });
    },

    // 协议确认弹窗确认操作
    dialogAction: function(e) {
      this.showDialog = false;
      if (!e) return; // 如果不是确认，直接返回
      
      // 如果是从首页temp链接跳转来的，需要显示套餐信息弹窗
      if (this.isFromTempLink) {
        console.log("从temp链接进入的问卷，显示套餐信息弹窗");
        
        // 显示套餐信息弹窗
        this.$nextTick(() => {
          this.showPackageInfo = true;
          console.log("套餐信息弹窗显示状态:", this.showPackageInfo);
        });
        return;
      }
        
      const pageType = this.$route.query.pageType;
      const type = Number(this.$route.query.type) || 0;
      const reviewOrderId = this.$route.query.reviewOrderId;
      const source = this.$route.query.source;

      // 开始判断什么订单进入什么操作
      if (type == 3) {
        // 单次预约：跳转到提交页，只展示单次套餐，让用户有机会选择优惠券
        this.$router.push({
          path: `/order/submit/${this.$route.params.id}`,
          query: { type: 3, reviewOrderId, source },
        });
      } else if (type == 2) {
        // 公益订单
        this.createOrder(1);
      } else {
        this.$router.push({
          path: `/order/submit/${this.$route.params.id}`,
          query:
            pageType == "coach"
              ? { type, pageType, reviewOrderId, source }
              : { type, reviewOrderId, source },
        });
      }
    },

    // 新增：获取可用优惠券列表
    async getAvailableCoupons(cartId, totalPrice, type) {
      const res = await getOrderCouponTemp(cartId, type, totalPrice);
      this.couponList = res.data || [];
    },

    // 新增：弹出优惠券选择弹窗
    openCouponSelector() {
      if (!this.cartId) {
        this.$dialog.toast({ mes: "请先选择套餐" });
        return;
      }
      this.showCoupon = true;
    },

    // 新增：处理优惠券选择
    handleCouponChecked(coupon) {
      this.usableCoupon = coupon || { couponTitle: "不使用优惠券", id: 0 };
      this.couponId = this.usableCoupon.id || 0;
      this.showCoupon = false;
    },

    // 新增：确认套餐信息按钮点击处理
    confirmPackageInfo: function() {
      console.log("确认套餐信息按钮被点击");
      this.showPackageInfo = false;
      console.log("套餐信息弹窗已关闭");
      
      // 记录当前套餐数据，用于调试
      console.log("当前套餐数据:", JSON.stringify(this.tempLinkData));
      
      // 确认后继续处理订单
      this.$nextTick(() => {
        console.log("准备处理订单...");
        this.processOrderFromTemp();
      });
    },

    // 新增：关闭套餐信息弹窗并返回首页
    closePackageInfo: function() {
      this.showPackageInfo = false;
      console.log("套餐信息弹窗已关闭，重置为正常下单流程");
      
      // 重置临时链接标识，让系统认为用户不是从临时链接进入的
      this.isFromTempLink = false;
      
      // 保存当前的产品ID，用于后续跳转
      const productId = this.$route.params.id || this.tempLinkData.productId;
      
      // 清除tempLinkData中的套餐信息，避免影响正常下单流程
      this.tempLinkData = {
        temp: null,
        orderId: null,
        uniqueId: "",
        productId: productId,
        price: 0,
        name: "",
        onePrice: 0,
        sku: ""
      };
      
      // 跳转到正常的套餐选择页面
      this.$router.replace({
        path: `/order/submit/${productId}`,
        query: {
          type: 1, // 表示续约类型，用户可以选择套餐
          source: 2,
          fromUserChoice: true // 标记这是用户主动选择进入正常流程的
        }
      });
      
      console.log("已重置为正常下单流程，用户可以自由选择套餐");
    },

    // 创建订单拉起支付
    async createOrder(welfareOrder) {
      this.$dialog.confirm({
        mes: "是否确认进行付款？",
        opts: async () => {
          const userRes = await getUserInfo();
          const userInfo = userRes.data;
          if (!userInfo.phone) {
            this.$dialog.confirm({
              mes: "您的用户基础信息尚未填写，为了便于教练联系到您，请补充完整。",
              opts: [
                {
                  txt: "返回",
                  color: false,
                  callback: () => {
                    this.$router.go(-1);
                  },
                },
                {
                  txt: "去完善",
                  color: true,
                  callback: () => {
                    this.$router.push("/settle_in?stepActive=1");
                  },
                },
              ],
            });
            return;
          }

          if (this.onBtn) return;
          const order = await this.createOrderKey();

          console.log("order", order)
          this.onBtn = true;
          this.$dialog.loading.open("正在拉起支付, 请稍后...");

          console.log("this.storeItems.id || order.systemStore.id", this.storeItems, order.systemStore)
          createOrder(order.orderKey, {
            realName: "",
            phone: "",
            addressId: null,
            channelid: null,
            welfareOrder: welfareOrder,
            useIntegral: 0,
            couponId: this.couponId || 0,
            payType: "weixin",
            pinkId: 0,
            seckillId: 1,
            from: this.from,
            combinationId: order.combination_id,
            bargainId: order.bargain_id,
            mark: "",
            shippingType: 1,
            storeId: this.storeItems.id || (order.systemStore || {}).id,
            firstOrder: 0,
            // 来源ID
            source: this.$route.query.source,
            // 如有测评ID
            reviewOrderId: this.$route.query.reviewOrderId,
          })
            .then((res) => {
              this.onBtn = false;
              this.$dialog.loading.close();
              const data = res.data;
              switch (data.status) {
                case "ORDER_EXIST":
                case "EXTEND_ORDER":
                case "PAY_DEFICIENCY":
                case "PAY_ERROR":
                  this.$dialog.toast({ mes: res.msg });
                  this.$router.replace({
                    path: "/order/status/" + data.result.orderId,
                    query: { 
                      type: this.type,
                      packageName: this.tempLinkData.name || "未知套餐",
                      packageSku: this.tempLinkData.sku || "",
                      packageOnePrice: this.tempLinkData.onePrice || 0
                    },
                  });
                  break;
                case "SUCCESS":
                  this.$dialog.success(res.msg);
                  this.$router.replace({
                    path: "/order/status/" + data.result.orderId,
                    query: {
                      price:
                        this.type == 1
                          ? this.productValue[0].price
                          : this.first_price,
                      type: this.type,
                      packageName: this.tempLinkData.name || "未知套餐",
                      packageSku: this.tempLinkData.sku || "",
                      packageOnePrice: this.tempLinkData.onePrice || 0
                    },
                  });
                  break;
                case "WECHAT_H5_PAY":
                  this.$router.replace({
                    path: "/order/status/" + data.result.orderId,
                    query: {
                      price:
                        this.type == 1
                          ? this.productValue[0].price
                          : this.first_price,
                      type: this.type,
                      packageName: this.tempLinkData.name || "未知套餐",
                      packageSku: this.tempLinkData.sku || "",
                      packageOnePrice: this.tempLinkData.onePrice || 0
                    },
                  });
                  setTimeout(() => {
                    location.href = data.result.jsConfig.mweb_url;
                  }, 100);
                  break;
                case "WECHAT_PAY":
                  pay(data.result.jsConfig).finally(() => {
                    this.$router.replace({
                      path: "/order/status/" + data.result.orderId,
                      query: {
                        price:
                          this.type == 1
                            ? this.productValue[0].price
                            : this.first_price,
                        type: this.type,
                        packageName: this.tempLinkData.name || "未知套餐",
                        packageSku: this.tempLinkData.sku || "",
                        packageOnePrice: this.tempLinkData.onePrice || 0
                      },
                    });
                  });
              }
            })
            .catch((err) => {
              console.log(err);
              this.onBtn = false;
              this.$dialog.loading.close();
              this.$dialog.error(err.msg || "创建订单失败");
            });
        },
      });
    },
    // 创建订单，获取订单key
    async createOrderKey() {
      // 相当于加入购物车
      this.$dialog.loading.open("开始创建订单");
      return new Promise((resolve, reject) => {
        postCartAdd({
          productId: this.$route.params.id,
          cartNum: 1,
          new: 1,
          uniqueId: this.$route.query.type == 1 ? "uniqueIdRe" : "", // 这里修复了缺少uniqueIdRe变量的问题
          from: this.$route.query.pageType == "coach" ? '1' : undefined, // 添加from参数处理公益教练
        }).then(goodsRes => {
          const cartIds = goodsRes.data.cartId;
          this.cartid = goodsRes.data.cartId;
          // 单次 0 (value = "订单类型 0 普通订单 1首约订单 2公益订单")
          let type = 0;
          this.$route.query.type == 0 && (type = 1)
          this.$route.query.type == 2 && (type = 2)
          postOrderConfirm(cartIds, type)
            .then((res) => {
              // this.$dialog.loading.close();
              resolve(res.data)
            })
            .catch(() => {
              this.$dialog.loading.close();
              this.$dialog.error("加载订单数据失败");
              reject()
            });
        }).catch(()=>{
          this.$dialog.loading.close();
          this.$dialog.error("加载订单数据失败");
          reject()
        })
        // reject()
      })
    },
    onConfirm: function (e) {
      this.form.providerId = e.id;
      this.form.provider = e.name;
      this.showPicker = false;
    },
    numConfirm: function (e) {
      this.form.childNum = e;
      this.numPicker = false;
    },
    sexConfirm: function (e) {
      this.form.childSex = e.value;
      this.form.childSexText = e.label;
      this.sexPicker = false;
    },
    relationConfirm: function (e) {
      this.form.childRelation = e.value;
      this.form.childRelationText = e.label;
      this.relationPicker = false;
    },
    directionConfirm: function (e) {
      this.form.direction = e.value;
      this.form.directionText = e.label;
      this.directionPicker = false;
      this.form.childNum = e.value == 1 ? 0 : 1;
      this.form.childSex = null;
      this.form.childSexText = "";
      this.form.childRelation = null;
      this.form.childRelationText = null;
    },
    dateTram(date) {
      return date
        ? `${new Date(date).getFullYear()}-${new Date(date).getMonth() > 8 ? "" : "0"
        }${new Date(date).getMonth() + 1}-${new Date(date).getDate() > 9 ? "" : "0"
        }${new Date(date).getDate()}`
        : "";
    },
    checkboxChange() {
      // 防止循环触发
      if (this.isProcessingCheckbox) {
        return;
      }
      
      this.isProcessingCheckbox = true;
      
      try {
        // 如果包含"以上均无"，则清除其他选项
        if (this.form.detailFjson.includes("99")) {
          this.form.detailFjson = ["99"];
        }
        // 如果包含其他选项，则清除"以上均无"
        else if (this.form.detailFjson.length > 0) {
          const idx = this.form.detailFjson.indexOf("99");
          if (idx !== -1) {
            this.form.detailFjson.splice(idx, 1);
          }
        }
      } finally {
        // 使用nextTick确保DOM更新后再重置标志位
        this.$nextTick(() => {
          this.isProcessingCheckbox = false;
        });
      }
    },
    checkTempParam() {
      // 检查是否从首页temp链接跳转而来
      const { temp, fromIndex, orderId, uniqueId, productId, price, name, onePrice, sku } = this.$route.query;
      
      // 如果有temp参数且fromIndex为true，表示是从首页带temp参数跳转过来的
      if (temp && fromIndex === 'true') {
        console.log("检测到来自首页的temp链接", temp);
        this.isFromTempLink = true;
        
        // 保存传递过来的参数
        this.tempLinkData = {
          temp,
          orderId: orderId || null,
          uniqueId: uniqueId || '',
          productId: productId || this.$route.params.id, // 如果没传，使用路由参数
          price: price || 0,
          onePrice: onePrice || 0, // 新增onePrice参数
          sku: sku || '', // 新增sku参数
          name: name || "未知套餐" // 使用从URL中获取的套餐名称，如果没有则默认为"未知套餐"
        };
        
        console.log("保存的temp链接数据:", this.tempLinkData);
      }
    },
    // 处理来自temp链接的订单
    processOrderFromTemp() {
      const { productId, uniqueId } = this.tempLinkData;
      if (!productId) {
        this.$dialog.toast({ mes: "获取产品信息失败" });
        return;
      }
      this.$dialog.loading.open("正在处理订单...");
      const orderData = {
        cartNum: 1,
        new: 1,
        productId: productId,
        uniqueId: uniqueId || ""
      };
      // 添加到购物车
      postCartAdd(orderData)
        .then(cartRes => {
          if (!cartRes || !cartRes.data || !cartRes.data.cartId) {
            this.$dialog.loading.close();
            this.$dialog.toast({ mes: "创建购物车失败" });
            return Promise.reject('无法获取购物车ID');
          }
          // 保存购物车ID
          const cartId = cartRes.data.cartId;
          this.cartId = cartId;
          // 拉取可用优惠券
          this.getAvailableCoupons(cartId, 1, 0); // 1为续约类型
          // 订单确认
          return postOrderConfirm(cartId, 0);
        })
        .then(orderRes => {
          console.log('订单确认结果:', orderRes);
          
          if (!orderRes || !orderRes.data || !orderRes.data.orderKey) {
            this.$dialog.loading.close();
            this.$dialog.toast({ mes: "订单确认失败" });
            return Promise.reject('订单确认失败');
          }
          
          // 保存订单确认数据
          const orderConfirmData = orderRes.data;
          console.log('订单确认数据:', orderConfirmData);
          
          // 构建创建订单的参数
          const createOrderData = {
            addressId: null,
            channelid: null,
            couponId: this.couponId || 0,
            firstOrder: 0, // 固定为0，因为temp链接是续约流程
            from: "weixin",
            mark: "",
            payType: "weixin",
            phone: "",
            pinkId: 0,
            realName: "",
            shippingType: 1,
            source: "2",
            useIntegral: 0,
            welfareOrder: 0
          };
          
          console.log('创建订单参数:', orderConfirmData.orderKey, createOrderData);
          
          // 创建订单
          return createOrder(orderConfirmData.orderKey, createOrderData);
        })
        .then(finalOrderRes => {
          this.$dialog.loading.close();
          console.log('订单创建结果:', finalOrderRes);
          
          if (!finalOrderRes) {
            console.warn('创建订单响应为空');
            this.$dialog.toast({ mes: "创建订单失败，请稍后重试" });
            return;
          }
          
          // 处理不同的支付状态
          const data = finalOrderRes.data;
          if (!data || !data.status) {
            this.$dialog.toast({ mes: "创建订单失败，请稍后重试" });
            return;
          }
          
          let orderId = null;
          
          switch (data.status) {
            case "ORDER_EXIST":
            case "EXTEND_ORDER":
            case "PAY_DEFICIENCY":
            case "PAY_ERROR":
              this.$dialog.toast({ mes: finalOrderRes.msg });
              // 跳转到订单状态页面
              if (data.result && data.result.orderId) {
                orderId = data.result.orderId;
                this.$router.replace({
                  path: "/order/status/" + orderId,
                  query: { 
                    type: 0,
                    price: this.tempLinkData.price || 0,
                    packageName: this.tempLinkData.name || "未知套餐",
                    packageSku: this.tempLinkData.sku || "",
                    packageOnePrice: this.tempLinkData.onePrice || 0
                  },
                });
              }
              break;
              
            case "SUCCESS":
              this.$dialog.success(finalOrderRes.msg);
              // 跳转到订单状态页面
              if (data.result && data.result.orderId) {
                orderId = data.result.orderId;
                this.$router.replace({
                  path: "/order/status/" + orderId,
                  query: {
                    type: 0,
                    price: this.tempLinkData.price || 0,
                    packageName: this.tempLinkData.name || "未知套餐",
                    packageSku: this.tempLinkData.sku || "",
                    packageOnePrice: this.tempLinkData.onePrice || 0
                  },
                });
              }
              break;
              
            case "WECHAT_H5_PAY":
              // H5支付，直接跳转到微信支付页面
              if (data.result && data.result.orderId) {
                orderId = data.result.orderId;
                // 先记录订单ID，然后跳转到微信H5支付
                this.$router.replace({
                  path: "/order/status/" + orderId,
                  query: {
                    type: 0,
                    price: this.tempLinkData.price || 0,
                    packageName: this.tempLinkData.name || "未知套餐",
                    packageSku: this.tempLinkData.sku || "",
                    packageOnePrice: this.tempLinkData.onePrice || 0
                  },
                });
                setTimeout(() => {
                  location.href = data.result.jsConfig.mweb_url;
                }, 100);
              }
              break;
              
            case "WECHAT_PAY":
              // 微信JSAPI支付，直接拉起支付
              if (data.result && data.result.jsConfig) {
                if (data.result.orderId) {
                  orderId = data.result.orderId;
                }
                // 使用pay方法拉起微信支付
                pay(data.result.jsConfig).finally(() => {
                  // 支付完成后跳转到订单状态页
                  if (orderId) {
                    this.$router.replace({
                      path: "/order/status/" + orderId,
                      query: {
                        type: 0,
                        price: this.tempLinkData.price || 0,
                        packageName: this.tempLinkData.name || "未知套餐",
                        packageSku: this.tempLinkData.sku || "",
                        packageOnePrice: this.tempLinkData.onePrice || 0
                      },
                    });
                  }
                });
              } else {
                this.$dialog.toast({ mes: "支付参数错误，请稍后重试" });
              }
              break;
              
            default:
              this.$dialog.toast({ mes: "未知状态，请前往订单列表查看" });
              // 跳转到订单列表
              setTimeout(() => {
                this.$router.push({
                  path: '/order/list',
                  query: { type: 0 } // 待付款订单
                });
              }, 1000);
          }
        })
        .catch(err => {
          this.$dialog.loading.close();
          console.error('订单创建流程失败:', err);
          this.$dialog.toast({ mes: typeof err === 'string' ? err : '创建订单失败，请稍后重试' });
        });
    },
    async onShowPackageInfo() {
      const cartRes = await postCartAdd({
        productId: this.tempLinkData.productId,
        cartNum: 1,
        new: 1,
        uniqueId: this.tempLinkData.uniqueId || ""
      });
      this.cartId = cartRes.data.cartId;
      if (this.cartId) {
        await this.getAvailableCoupons(this.cartId, 1, 0);
      }
    },
  },
  watch: {
    showPackageInfo(val) {
      if (val) {
        this.onShowPackageInfo();
      }
    },
  },
};
</script>
<style scoped>
.question-item {
  padding: 0.38rem 0 0.19rem;
  color: #333333;
  border-bottom: none;
}

.question-item .input {
  margin-top: 0;
}

.question-item .name {
  flex: 1;
}

.box-check {
  padding: 0.19rem 0;
}

/* 复制GoodsCon.vue中的协议弹窗样式 */
.agree-content {
  width: 80vw;
  min-height: 20vh;
  max-height: 60vh;
  overflow-x: hidden;
  overflow-y: scroll;
  padding: 0.3rem;
}

.agree-title {
  padding: 0.3rem;
  text-align: center;
  font-size: 0.3rem;
  font-weight: 700;
}

.agree-btn {
  display: block;
  color: #fff;
  height: 0.68rem;
  background: #0ce6df;
  line-height: 0.68rem;
  text-align: center;
  border-radius: 0.5rem;
  margin: 0.3rem;
}

/* 套餐信息弹窗样式 */
.package-content {
  padding: 0.5rem 0.3rem;
  min-height: 3rem;
  width: 80vw;
}

.package-item {
  margin-bottom: 0.5rem;
  font-size: 0.32rem;
  line-height: 1.5;
  display: flex;
}

.package-label {
  color: #666;
  width: 2.2rem;
  font-weight: normal;
}

.package-value {
  color: #333;
  flex: 1;
  font-weight: bold;
}

.package-value.price {
  color: #f56c6c;
  font-weight: bold;
  font-size: 0.36rem;
}

.popup-close-icon {
  position: absolute;
  top: 0px;
  right: 0px;
  font-size: 0.5rem;
  color: #666;
  cursor: pointer;
  padding: 0.2rem;
  z-index: 10;
}
</style>
